export default {
  Webinar: require('./webinar').default,
  PembelajaranMandiri: require('./pembelajaran-mandiri').default,
}